import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["alert"];

  connect() {
    // Auto-hide flash messages after 5 seconds
    this.alertTargets.forEach(alert => {
      setTimeout(() => {
        this.hideAlert(alert);
      }, 5000);
    });
  }

  close(event) {
    const alert = event.target.closest(".alert");
    if (alert) {
      this.hideAlert(alert);
    }
  }

  hideAlert(alert) {
    if (alert && alert.parentNode) {
      alert.style.transition = "opacity 0.3s ease";
      alert.style.opacity = "0";
      setTimeout(() => {
        if (alert.parentNode) {
          alert.remove();
        }
      }, 300);
    }
  }
}
